import gql from "graphql-tag";
const getAllPosition = gql`
  query($status: String, $query: String, $limit: Int, $page: Int) {
    getAllPosition(
      status: $status
      query: $query
      paging: { limit: $limit, page: $page }
    ) {
      id
      name
      updatedAt
      createdAt
      status
    }
  }
`;

export default { getAllPosition };
